//@ts-expect-error this file isn't typed
import getPortalId from '../../common/selectors/getPortalId';
//@ts-expect-error this file isn't typed
import { threadHistoryFailed } from '../../thread-histories/selectors/threadHistoryFailed';
//@ts-expect-error this file isn't typed
import { fetchAgentHistory as agentHistoryFetcher } from '../../thread-histories/actions/fetchAgentHistory';
//@ts-expect-error this file isn't typed
import { getMergedMessagesList } from '../selectors/getMergedMessagesList';
import UnifiedThreadHistory from './UnifiedThreadHistory';
//@ts-expect-error this file isn't typed
//@ts-expect-error this file isn't typed
import { getCurrentVid } from '../../crm-integration/selectors/getCurrentVid';
//@ts-expect-error this file isn't typed
import { getIncomingThreadId } from '../../performance-metrics/selectors/getIncomingThreadId';
//@ts-expect-error this file isn't typed
import { getAsyncThreadHistory } from '../../thread-histories/selectors/getAsyncThreadHistory';
import { getUserId } from 'conversations-thread-data/auth/public/selectors';
import { InboxConfig } from '../configs/InboxConfig';
//@ts-expect-error this file isn't typed
import { provideThreadView } from '../../thread-view/decorators/provideThreadView';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const useUnifiedThreadHistory = ({
  threadId,
  historyConfig = InboxConfig
}) => {
  const dispatch = useDispatch();
  const fetchAgentHistory = useCallback(({
    threadId: passedThreadId,
    offsetTimestamp,
    offsetOrdinal,
    includeDeletedMessages
  }) => dispatch(agentHistoryFetcher({
    threadId: passedThreadId,
    offsetTimestamp,
    offsetOrdinal,
    includeDeletedMessages
  })), [dispatch]);
  const asyncThreadHistory = useSelector(state => getAsyncThreadHistory(state, {
    threadId
  }));
  const currentUserId = useSelector(getUserId);
  const incomingThreadId = useSelector(getIncomingThreadId);
  const messagesList = useSelector(state => getMergedMessagesList(state, {
    threadId,
    historyConfig
  }));
  const portalId = useSelector(getPortalId);
  const threadHistoryRequestFailed = useSelector(state => threadHistoryFailed(state, {
    threadId
  }));
  const vid = useSelector(getCurrentVid);
  return {
    asyncThreadHistory,
    currentUserId,
    incomingThreadId,
    messagesList,
    portalId,
    threadHistoryRequestFailed,
    vid,
    fetchAgentHistory
  };
};
const ConnectedUnifiedThreadHistory = ({
  allowContactPromotions,
  threadId,
  historyConfig = InboxConfig,
  AsyncUIAvatar,
  canRestoreMessagesForThread,
  slots
}) => {
  const {
    asyncThreadHistory,
    currentUserId,
    incomingThreadId,
    messagesList,
    portalId,
    threadHistoryRequestFailed,
    vid,
    fetchAgentHistory
  } = useUnifiedThreadHistory({
    threadId,
    historyConfig
  });
  return /*#__PURE__*/_jsx(UnifiedThreadHistory, {
    allowContactPromotions: allowContactPromotions,
    asyncThreadHistory: asyncThreadHistory,
    currentUserId: currentUserId,
    incomingThreadId: incomingThreadId,
    messagesList: messagesList,
    portalId: portalId,
    threadHistoryRequestFailed: threadHistoryRequestFailed,
    vid: vid,
    fetchAgentHistory: fetchAgentHistory,
    threadId: threadId,
    historyConfig: historyConfig,
    AsyncUIAvatar: AsyncUIAvatar,
    canRestoreMessagesForThread: canRestoreMessagesForThread,
    slots: slots
  });
};
ConnectedUnifiedThreadHistory.displayName = 'ConnectedUnifiedThreadHistory';
export default provideThreadView(ConnectedUnifiedThreadHistory);